function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useState, useMemo } from 'react';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { SearchkitProvider, SearchkitClient } from '@searchkit/client';
import PropTypes from 'prop-types';
import Query from './Query';
import SearchField from './SearchField';
import SearchPagination from './SearchPagination';
import SearchResults from './SearchResults';
import SearchFacets from './SearchFacets';
import SearchSelectedFilters from './SearchSelectedFilters';
var defaultChildren = function defaultChildren(data, loading) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchField, null), /*#__PURE__*/React.createElement(SearchFacets, {
    data: data,
    loading: loading
  }), /*#__PURE__*/React.createElement(SearchSelectedFilters, {
    data: data,
    loading: loading
  }), /*#__PURE__*/React.createElement(SearchResults, {
    data: data
  }), /*#__PURE__*/React.createElement(SearchPagination, {
    data: data
  }));
};
var SearchKit = function SearchKit(_ref) {
  var query = _ref.query,
    uri = _ref.uri,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
    _ref$useRouting = _ref.useRouting,
    useRouting = _ref$useRouting === void 0 ? true : _ref$useRouting,
    _ref$defaultFilters = _ref.defaultFilters,
    defaultFilters = _ref$defaultFilters === void 0 ? [] : _ref$defaultFilters,
    _ref$defaultQuery = _ref.defaultQuery,
    defaultQuery = _ref$defaultQuery === void 0 ? '' : _ref$defaultQuery,
    children = _ref.children,
    _ref$defaultSorting = _ref.defaultSorting,
    defaultSorting = _ref$defaultSorting === void 0 ? 'relevance' : _ref$defaultSorting;
  var client = useMemo(function () {
    return new ApolloClient({
      uri: uri,
      cache: new InMemoryCache()
    });
  }, [uri]);
  var skClient = useMemo(function () {
    var skClient = new SearchkitClient();
    skClient.updateBaseSearchState({
      filters: defaultFilters,
      query: defaultQuery,
      page: {
        size: pageSize,
        from: 0
      },
      sortBy: defaultSorting
    });

    // We override the setQuery and resetFilters functions to include our default filters,
    // e.g when you do a new search query or press the reset button.
    skClient.setQuery = function (query) {
      // eslint-disable-next-line react/no-this-in-sfc
      this.setSearchState(function (searchState) {
        return _objectSpread(_objectSpread({}, searchState), {}, {
          query: query,
          filters: defaultFilters,
          page: {
            from: 0,
            size: pageSize
          }
        });
      });
    };
    skClient.resetFilters = function (query) {
      // eslint-disable-next-line react/no-this-in-sfc
      this.setSearchState(function (searchState) {
        return _objectSpread(_objectSpread({}, searchState), {}, {
          filters: defaultFilters
        });
      });
    };
    return skClient;
  }, [useRouting, defaultFilters, defaultQuery, pageSize, defaultSorting]);
  return /*#__PURE__*/React.createElement(ApolloProvider, {
    client: client
  }, /*#__PURE__*/React.createElement(SearchkitProvider, {
    client: skClient,
    key: "".concat(defaultQuery, "-").concat(defaultFilters.toString())
  }, /*#__PURE__*/React.createElement(Query, {
    query: query,
    useRouting: useRouting
  }, function (data, loading) {
    return children ? children(data, loading) : defaultChildren(data, loading);
  })));
};
SearchKit.propTypes = {
  uri: PropTypes.string,
  pageSize: PropTypes.number,
  useRouting: PropTypes.bool,
  defaultFilters: PropTypes.object,
  defaultQuery: PropTypes.string,
  defaultSorting: PropTypes.string
};
SearchKit.defaultProps = {
  uri: null,
  pageSize: 10,
  useRouting: true,
  defaultFilters: [],
  defaultQuery: '',
  defaultSorting: 'relevance'
};
export default SearchKit;